module.exports = __webpack_public_path__ + "img/news5-1.5faee0d4.png";